<div>
  <tyt-sub-nav [show]="show" [activeLiveStream]="activeLiveStream" [section]="section"></tyt-sub-nav>

  @if (!show) {
    <app-spinner style="min-height: 70vh;"></app-spinner>
  }

  <div class="layout">
    <div class="main-content">
      @if (state === 'production-not-found') {
        <tyt-not-found
          [checkRedirect]="false" [checkForUpdates]="false"
          message="We couldn't find the episode you were looking for."
        ></tyt-not-found>
      }
      @if (state === 'show-not-found') {
        <tyt-not-found
          [checkRedirect]="false" [checkForUpdates]="false"
          message="We couldn't find the show you were looking for."
        ></tyt-not-found>
      }
      @if (state === 'production') {
        <tyt-production-view
          [production]="production"
          [includeItems]="false"
          />
        <mat-tab-group mat-stretch-tabs="false" class="production-content">
          @if (production.full_length_vods.length > 0) {
            <mat-tab label="Episode" labelClass="episodes">
              <tyt-production-view
                [production]="production"
                mode="episodes"
                [includeMetadata]="false"
                [showFeedTag]="false"
                />
            </mat-tab>
          }
          @if (production.vod_clips.length > 0) {
            <mat-tab label="Clips" labelClass="clips">
              <tyt-production-view
                [production]="production"
                mode="clips"
                [includeMetadata]="false"
                [showFeedTag]="false"
                />
            </mat-tab>
          }
          @if (production.full_length_podcasts.length > 0) {
            <mat-tab label="Podcast" labelClass="podcasts">
              <tyt-production-view
                [production]="production"
                mode="podcasts"
                [includeMetadata]="false"
                />
            </mat-tab>
          }
        </mat-tab-group>
      }
      @if (state === 'normal') {
        @if (section === 'content') {
          <mat-menu #filterMenu>
            <a mat-menu-item routerLink="/shows/{{ show.slug ?? show.id }}">All</a>
            <a mat-menu-item routerLink="/shows/{{ show.slug ?? show.id }}/episodes">Episodes</a>
            <a mat-menu-item routerLink="/shows/{{ show.slug ?? show.id }}/clips">Clips</a>
            <a mat-menu-item routerLink="/shows/{{ show.slug ?? show.id }}/podcasts">Podcasts</a>
          </mat-menu>
          <button mat-button [matMenuTriggerFor]="filterMenu" class="filter">
            <mat-icon>filter_list</mat-icon>
            @if (requestedSection === 'content') {
              All
            }
            @if (requestedSection === 'episodes') {
              Episodes
            }
            @if (requestedSection === 'clips') {
              Clips
            }
            @if (requestedSection === 'podcasts') {
              Podcasts
            }
          </button>
          @if (!productions) {
            <div class="v-center">
              <app-spinner></app-spinner>
            </div>
          } @else {
            @for (episode of productions; track episode; let i = $index) {
              @if (hasItemsOfRequestedType(episode)) {
                <div class="production">
                  @if (productionMode === 'content') {
                    <tyt-production-view
                      [production]="episode"
                      [includeItems]="false"
                      [style.animation-delay]="(i * 100)+'ms'">
                    </tyt-production-view>
                    <mat-tab-group mat-stretch-tabs="false" class="production-content">
                      @if (episode.full_length_vods.length > 0) {
                        <mat-tab label="Episode" labelClass="episodes">
                          <tyt-production-view
                            [production]="episode"
                            mode="episodes"
                            [includeMetadata]="false"
                            [showFeedTag]="false"
                            [style.animation-delay]="(i * 100)+'ms'"
                          ></tyt-production-view>
                        </mat-tab>
                      }
                      @if (episode.vod_clips.length > 0) {
                        <mat-tab label="Clips" labelClass="clips">
                          <tyt-production-view
                            [production]="episode"
                            mode="clips"
                            [includeMetadata]="false"
                            [showFeedTag]="false"
                            [style.animation-delay]="(i * 100)+'ms'"
                          ></tyt-production-view>
                        </mat-tab>
                      }
                      @if (episode.full_length_podcasts.length > 0) {
                        <mat-tab label="Podcast" labelClass="podcasts">
                          <tyt-production-view
                            [production]="episode"
                            mode="podcasts"
                            [includeMetadata]="false"
                            [style.animation-delay]="(i * 100)+'ms'"
                          ></tyt-production-view>
                        </mat-tab>
                      }
                    </mat-tab-group>
                  } @else {
                    <tyt-production-view
                      [production]="episode"
                      [mode]="productionMode"
                      [style.animation-delay]="(i * 100)+'ms'">
                    </tyt-production-view>
                  }
                </div>
              }
            }
          }
        }
        @if (section === 'articles') {
          @if (!articles) {
            <div class="v-center">
              <app-spinner></app-spinner>
            </div>
          } @else {
            @for (article of articles; track article) {
              <tyt-article-list-item [article]="article">
              </tyt-article-list-item>
            }
          }
        }
        @if (section === 'about') {
          <div class="about-description">
            <div class="cms-content" [innerHTML]="show.description | markdownToHtml | trustHtml"></div>
            @if (twitter_handle || youtube_handle || facebook_handle || instagram_handle) {
              <div class="socials">
                <h2>Follow {{ show.name }}!</h2>
                <div class="social-links">
                  @if (web_url) {
                    <a target="_blank" href="https://{{web_url}}">
                      <mat-icon>public</mat-icon>{{web_url}}
                    </a>
                  }
                  @if (twitter_handle) {
                    <a target="_blank" href="https://twitter.com/{{twitter_handle}}">
                      <img src="/assets/icons/twitter.svg" alt="twitter" class="icon">&#64;{{twitter_handle}}
                    </a>
                  }
                  @if (youtube_handle) {
                    <a target="_blank" href="https://{{youtube_handle}}">
                      <img src="/assets/icons/youtube.svg" alt="youtube" class="icon">{{youtube_handle}}
                    </a>
                  }
                  @if (facebook_handle) {
                    <a target="_blank" href="https://{{facebook_handle}}">
                      <img src="/assets/icons/facebook.svg" alt="facebook" class="icon">{{facebook_handle}}
                    </a>
                  }
                  @if (instagram_handle) {
                    <a target="_blank" href="https://www.instagram.com/{{instagram_handle}}">
                      <img src="/assets/icons/iconmonstr-instagram-11.svg" alt="instagram" class="icon">&#64;{{instagram_handle}}
                    </a>
                  }
                </div>
              </div>
            }
          </div>
          @if (show) {
            <div class="mobile-only">
              <tyt-feed-tag>Hosts</tyt-feed-tag>
              <div class="hosts">
                @for (host of show.hosts; track host) {
                  <a class="talent-link" [routerLink]="(host.username && shouldShowTalentUser) ? '@/'+host.username : '/about/talent/'+host.id">
                    <div class="host-portrait" [responsiveBackgroundImage]="host.thumbnail_portrait1"></div>
                    <p class="host-name">{{ host.name }}</p>
                  </a>
                }
              </div>
            </div>
          }
        }
        @if (page && isPageableSection(section)) {
          <tyt-pager [total]="page.total" [page]="page.page" [size]="pageSize" (changePage)="goToPage($event)">
          </tyt-pager>
        }
      }
    </div>
    <aside>
      @if (section !== 'about' && show && show.tune_ins.length) {
        <tyt-tune-in [showName]="show.name" [showId]="show.id" [tuneIns]="show.tune_ins"></tyt-tune-in>
      }
      @if (section === 'about' && show && show.hosts) {
        <div class="no-mobile">
          <tyt-feed-tag>Hosts</tyt-feed-tag>
          @for (host of show.hosts; track host) {
            <a class="talent-link" [routerLink]="(host.username && shouldShowTalentUser) ? '@/'+host.username : '/about/talent/'+host.id">
              <div class="host-portrait" [responsiveBackgroundImage]="host.thumbnail_portrait1"></div>
              <p class="host-name">{{ host.name }}</p>
            </a>
          }
        </div>
      }
    </aside>
  </div>
  @if (isLastPage) {
    <div class="call-to-action">
      <h2>
        <mat-icon>history</mat-icon>
        Want to Go Back Even Further?
      </h2>
      <p>Check out the TYT Archives to discover and explore our vast library of resources.</p>
      <a role="button" routerLink="/archive/search/results" [queryParams]="{ show: show.slug || show.id }">
        Visit TYT Archives
      </a>
    </div>
  }
</div>
